import { cn } from "@/lib/utils";

/** Loading-state placeholder. Use anywhere a real value is going to land. */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

export { Skeleton };
